import StyledTableCell from "@components/Table/TableCell";
import StyledTableRow from "@components/Table/TableRow";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";

interface StepsExternalVarsSkeletonProps {
  columnsCount?: number;
  rowsCount?: number;
}

const StepsExternalVarsSkeleton = ({
  columnsCount = 8,
  rowsCount = 4
}: StepsExternalVarsSkeletonProps) => {
  return (
    <Box className="w-full mt-8">
      <Box className="w-full ml-4">
        {/* Title skeleton */}
        <Skeleton variant="text" width={150} height={40} />

        {/* Select dropdowns skeleton */}
        <Box className="w-1/3 flex mt-2">
          <Box sx={{ width: "100%" }}>
            <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
          </Box>
          <Box sx={{ width: "100%", ml: 2 }}>
            <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
          </Box>
        </Box>
      </Box>

      {/* Table skeleton */}
      <TableContainer className="p-4">
        <Table className="w-full" aria-label="external vars table skeleton">
          <TableHead>
            <TableRow>
              {/* Variable header */}
              <StyledTableCell align="center">
                <Skeleton variant="text" width="80%" sx={{ mx: "auto" }} />
              </StyledTableCell>
              {/* Time period headers */}
              {Array.from({ length: columnsCount }).map((_, index) => (
                <StyledTableCell
                  align="center"
                  key={`header-skeleton-${index}`}
                >
                  <Skeleton variant="text" width="60%" sx={{ mx: "auto" }} />
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Variable rows */}
            {Array.from({ length: rowsCount }).map((_, rowIndex) => (
              <StyledTableRow
                key={`row-skeleton-${rowIndex}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {/* Variable name cell */}
                <StyledTableCell align="center">
                  <Skeleton variant="text" width="70%" sx={{ mx: "auto" }} />
                </StyledTableCell>
                {/* Value cells */}
                {Array.from({ length: columnsCount }).map((_, colIndex) => (
                  <StyledTableCell
                    align="center"
                    key={`cell-skeleton-${rowIndex}-${colIndex}`}
                  >
                    <Skeleton
                      variant="rounded"
                      width="80%"
                      height={36}
                      sx={{ mx: "auto", borderRadius: 1 }}
                    />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default StepsExternalVarsSkeleton;
